module.exports = __webpack_public_path__ + "main/images/shared/app-store-badge.ee8fc18225c5b13e0dbdd0b4143f4ecf.svg";